import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import styles from './MembersTable.module.scss';

const sortMembers = (data, field, dir) => {
    return [...data].sort((a, b) => {
        const aVal = a[field] ?? '';
        const bVal = b[field] ?? '';
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return dir === 'asc' ? aVal - bVal : bVal - aVal;
        }
        const aStr = String(aVal).toLowerCase();
        const bStr = String(bVal).toLowerCase();
        if (aStr < bStr) return dir === 'asc' ? -1 : 1;
        if (aStr > bStr) return dir === 'asc' ? 1 : -1;
        return 0;
    });
};

const exportToCsv = (members) => {
    const headers = ['Last Name', 'First Name', 'Email', 'Phone', 'Type', 'Balance', 'CheckIns'];
    const rows = members.map(m => [
        m.lastName,
        m.firstName,
        m.email ?? '',
        m.mobile ?? '',
        m.customerType ?? '',
        m.balance ?? '',
        m.checkins ?? '',
    ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','));
    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'members.csv';
    a.click();
    URL.revokeObjectURL(url);
};

const MembersTable = ({ data, keywords, emailFilter, userType, showModal, setSelectedMember, showGuestModal, setGuestMember, showAllGuestsModal, showAllCheckInsModal }) => {
    const [sortField, setSortField] = useState('lastName');
    const [sortDir, setSortDir] = useState('asc');

    const handleSort = (field) => {
        if (field === sortField) {
            setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir('asc');
        }
    };

    const indicator = (field) => field === sortField ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '';

    const thStyle = { cursor: 'pointer', userSelect: 'none' };

    let members = data && sortMembers(data, sortField, sortDir).filter(item => {
        const name = item.lastName.toLowerCase();
        const email = item.email && item.email.toLowerCase();
        return name.includes(keywords.toLowerCase())
            || ((emailFilter && email) && email.includes(keywords.toLowerCase()));
    });

    const viewMemberHandler = (member) => {
        showModal();
        setSelectedMember(member);
    };

    const guestHandler = (member) => {
        setGuestMember(member);
        showGuestModal();
    };

    return (
        <div className={styles.Wrapper}>
            { userType === "manager" && members && (
                <div className={styles.ExportRow}>
                    <Button variant="outline-primary" size="sm" onClick={showAllGuestsModal} className="mr-2">
                        Guest Log
                    </Button>
                    <Button variant="outline-info" size="sm" onClick={showAllCheckInsModal} className="mr-2">
                        Check-In Log
                    </Button>
                    <Button variant="outline-secondary" size="sm" onClick={() => exportToCsv(members)}>
                        Export to CSV
                    </Button>
                </div>
            )}
            <Table striped bordered className={styles.Table}>
                <thead>
                <tr>
                    <th style={{ width: userType === "manager" ? "30%" : "80%", ...thStyle }}
                        onClick={() => handleSort('lastName')}>
                        Account Name{indicator('lastName')}
                    </th>
                    { userType === "manager" && <th className={styles.EmailHeader} style={thStyle} onClick={() => handleSort('email')}>
                        Email{indicator('email')}
                    </th> }
                    { userType === "manager" && <th className={styles.customerTypeHeader} style={thStyle} onClick={() => handleSort('mobile')}>
                        Phone{indicator('mobile')}
                    </th> }
                    { userType === "manager" && <th className={styles.customerTypeHeader} style={thStyle} onClick={() => handleSort('customerType')}>
                        Type{indicator('customerType')}
                    </th> }
                    { userType === "manager" && <th className={styles.BalanceHeader} style={thStyle} onClick={() => handleSort('balance')}>
                        Balance{indicator('balance')}
                    </th> }
                    <th className={styles.BalanceHeader} style={thStyle} onClick={() => handleSort('checkins')}>
                        CheckIns{indicator('checkins')}
                    </th>
                    <th className={styles.ViewHeader}>View</th>
                    <th className={styles.ViewHeader}>Guest</th>
                </tr>
                </thead>
                <tbody>
                { members && members.map(member => (
                    <tr key={member.customerIndex} >
                        <td>{ member.lastName }, { member.firstName }</td>
                        { userType === "manager" && <td>{ member.email }</td>}
                        { userType === "manager" && <td>{ member.mobile }</td>}
                        { userType === "manager" && <td>{ member.customerType}</td>}
                        { userType === "manager" && <td>{ member.balance }</td>}
                        <td>{ member.checkins }</td>
                        <td>
                            <Button variant="info" onClick={() => viewMemberHandler(member)}>View</Button>
                        </td>
                        <td>
                            <Button variant="success" onClick={() => guestHandler(member)}>Guest</Button>
                        </td>
                    </tr>
                )) }

                { members === null && (
                    <>
                        <tr />
                        <tr>
                            <td colSpan={5}>
                                <div className={styles.LoadingWrapper}>
                                    <Spinner animation="border" />
                                </div>
                            </td>
                        </tr>
                    </>
                )}
                </tbody>
            </Table>
        </div>
    );
};

export default MembersTable;
